export const MessagingDBGroup = 'messaging';
//# sourceMappingURL=consts.js.map